import React, { useState } from "react";
import { getStorage, ref, uploadBytes, getDownloadURL } from "firebase/storage";
import { getFirestore, doc, updateDoc } from "firebase/firestore";


const ConfigCV = ({ profileData = {}, setProfileData }) => {
  const db = getFirestore();
  const storage = getStorage();

  const [uploading, setUploading] = useState(false);
  const [alertMessage, setAlertMessage] = useState("");
  const [selectedVideo, setSelectedVideo] = useState(null); // Video seleccionado
  const [selectedImage, setSelectedImage] = useState(null);
  // Inicializar `profileData` si es undefined o vacío
  const profileDataSafe = {
    ...profileData,
    videos: profileData.videos || [],
  };

  const handleInputChange = (e) => {
    const { name, value, maxLength } = e.target;
    if (value.length <= maxLength) {
      setProfileData({
        ...profileDataSafe,
        [name]: name === "skills" ? value.split(",").map(s => s.trim()) : value
      });
    }
  };
  
  const handleImageSelection = (e) => {
    const file = e.target.files[0];
    if (file && file.type.startsWith("image/")) {
      setSelectedImage(file);
    } else {
      setAlertMessage("Solo se permiten archivos de imagen.");
    }
  };

  const handleVideoSelection = (e) => {
    const file = e.target.files[0];
    setSelectedVideo(file); // Guardar el video seleccionado en el estado
  };

  const handleSave = async () => {
    setAlertMessage("");
    setUploading(true);
  
    try {
      let updatedVideos = [...profileDataSafe.videos];
      let updatedProfileData = { ...profileDataSafe }; // ✅ Declarar antes de modificar
  
      // Subir video si hay uno seleccionado
      if (selectedVideo) {
        if (selectedVideo.size > 50 * 1024 * 1024) {
          setAlertMessage("El archivo supera los 50 MB.");
          setUploading(false);
          return;
        }
  
        const videoElement = document.createElement("video");
        videoElement.src = URL.createObjectURL(selectedVideo);
  
        const isVideoValid = await new Promise((resolve) => {
          videoElement.onloadedmetadata = () => {
            resolve(videoElement.duration <= 30);
          };
        });
  
        if (!isVideoValid) {
          setAlertMessage("El video no puede exceder los 30 segundos.");
          setUploading(false);
          return;
        }
  
        const storageRef = ref(storage, `videos/${selectedVideo.name}`);
        await uploadBytes(storageRef, selectedVideo);
        const fileURL = await getDownloadURL(storageRef);
  
        updatedVideos.push(fileURL);
        updatedProfileData.videos = updatedVideos; 
        setSelectedVideo(null);
      }
  
      // Subir imagen si hay una seleccionada
      if (selectedImage) {
        const imageRef = ref(storage, `profileImages/${selectedImage.name}`);
        await uploadBytes(imageRef, selectedImage);
        const imageUrl = await getDownloadURL(imageRef);
        updatedProfileData.profileImage = imageUrl; 
      }
  
      // Guardar en Firestore
      const userRef = doc(db, "postulantes", profileDataSafe.uid);
      await updateDoc(userRef, updatedProfileData);
  
      setProfileData(updatedProfileData);
      setAlertMessage("Datos guardados con éxito.");
    } catch (error) {
      console.error("Error al guardar los datos del perfil:", error);
      setAlertMessage("Hubo un problema al guardar tus datos.");
    } finally {
      setUploading(false);
    }
  };
  

  return (
    <div className="tab-content">
      <div className="cv-tips">
        <h4>Consejos para tu Currículum</h4>
        <ul>
          <li>Sé claro y conciso.</li>
          <li>Personaliza tu CV para cada trabajo.</li>
          <li>Usa un diseño limpio y profesional.</li>
          <li>Incluye logros, no solo responsabilidades.</li>
          <li>Revisa la ortografía y gramática.</li>
        </ul>
      </div>

      {/* Consejos para el Video */}
      <div className="video-tips">
        <h4>Consejos para tu Video</h4>
        <ul>
          <li>Solo tienes 30 segundos.</li>
          <li>Habla con confianza y autenticidad.</li>
          <li>Evita distracciones y busca buena iluminación.</li>
          <li>Resalta tus logros más importantes.</li>
          <li>Muestra por qué quieres trabajar en esta empresa.</li>
          <li>Muestra por qué deben contratarte a tí.</li>
        </ul>
      </div>
      <h3>Configuración de Oficina</h3>
      <div className="icon-container">
        <label htmlFor="image-upload" className="video-upload-label">
          {uploading ? (
            <i className="fas fa-spinner fa-spin"></i>
          ) : (
            <i className="fas fa-image"></i> // Ícono de imagen
          )}
        </label>
      </div>

      <input
        type="file"
        id="image-upload"
        accept="image/*"
        onChange={handleImageSelection}
        style={{ display: "none" }} 
      />

      {selectedImage && <p>Imagen seleccionada: {selectedImage.name}</p>}

      {/* Contenedor para el icono centrado */}
      <div className="icon-container">
        <label
          htmlFor="video-upload"
          className="video-upload-label"
        >
          {uploading ? (
            <i className="fas fa-spinner fa-spin"></i> // Icono de carga mientras sube
          ) : (
            <i className="fas fa-video"></i> // Icono normal de video
          )}
        </label>
      </div>

      <input
        type="file"
        id="video-upload"
        accept="video/*"
        onChange={handleVideoSelection}
        style={{ display: "none" }} // Ocultar el input
      />

      {/* Mostrar el nombre del video seleccionado */}
      {selectedVideo && <p>Video seleccionado: {selectedVideo.name}</p>}

      {/* Mensaje de carga */}
      {uploading && <p style={{ color: "blue" }}>Cargando archivos, por favor espera...</p>}

      {/* Mostrar videos subidos */}
      {profileDataSafe.videos.length > 0 && (
        <div>
          <h4>Videos subidos:</h4>
          {profileDataSafe.videos.map((videoURL, index) => (
            <div key={index}>
              <video
                src={videoURL}
                controls
                style={{ maxWidth: "300px", width: "100%", marginBottom: "10px" }}
              />
            </div>
          ))}
        </div>
      )}

      {/* Campos de formulario */}
      <label>
        Sobre mi:
        <textarea
          name="about" placeholder="habla sobre tí, gustos, intereses, metas, etc. Max. 600 caracteres"
          value={profileDataSafe.about || ""} maxLength={600}
          onChange={handleInputChange}
        />
      </label>
      <label>
        Habilidades:
        <textarea
          name="skills" placeholder="separá las habilidades por comas (,) Max. 200 caracteres"
          value={profileDataSafe.skills || ""}
          onChange={handleInputChange} maxLength={200}
        />
      </label>
      <label>
        Experiencia laboral:
        <textarea
          name="experience"
          value={profileDataSafe.experience || ""}
          onChange={handleInputChange} maxLength={600}
        />
      </label>
      <label>
        Remuneración requerida:
        <input
          type="text"
          name="salary" maxLength={100}
          value={profileDataSafe.salary || ""}
          onChange={handleInputChange}
        />
      </label>
      <label>
        Tipo de experiencia buscada:
        <input
          type="text"
          name="jobExpectations"
          value={profileDataSafe.jobExpectations || ""}
          onChange={handleInputChange} maxLength={300}
        />
      </label>

      {/* Botón para guardar */}
      <button className="btn btn-primary" onClick={handleSave} disabled={uploading}>
        Guardar cambios
      </button>

      {/* Mensaje de alerta */}
      {alertMessage && (
        <p style={{ color: alertMessage.includes("éxito") ? "green" : "red" }}>
          {alertMessage}
        </p>
      )}
    </div>
  );
};

export default ConfigCV;
